export enum CommonLoanSummaryInvokingFeatureType {
    PropertyInsurance = 0,
    BuildRentConversion = 1,
    LinkLoanWithBClient = 2,
    ReleaseHoldback = 3,
    RentalDscr = 4,
    LoanRepayment = 5,
    RestoreLoan = 6,
    RevertLoanToApprovedStatus = 7,
    TerminateMasterNote = 8,
}
